import { createRoot } from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import App from "../App"
import "../styles/global.css"

const container = document.getElementById("root")

if (container) {
  createRoot(container).render(
    <BrowserRouter>
      <App />
    </BrowserRouter>
  )
}
